import React, { Fragment } from 'react';
import cn from 'classnames';

import Header from 'components/Header';
import { Grid, Column } from 'components/Layout';

import style from './style.scss';

const FundingInformation = () => (
  <Fragment>
    <Header />
    <section className="container section">
      <div className="grid-container fluid portal page-funding-info">

        <Grid>
          <Column className="small-12 card-grid-container">

            <Grid className={cn('grid-margin-x page-header', style.pageHeader)}>
              <Column className="small-12">
                <h3>Funding Profile</h3>
              </Column>
            </Grid>

            <Grid className={cn('grid-margin-x page-header', style.pageHeader)}>
              <Column className="small-12">

                <div className="card card-editable">
                  <div className="card-header">
                    <h5>Bank Account Information</h5>
                    <button className="button green hide save-btn">Save Changes</button>
                  </div>

                  <div className="card-section">
                    <p>If you need to make any changes to your bank information, please contact us.</p>
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-12 large-4">
                        <label className="has-value"><span>Account Holder Name</span>
                          <input type="text" value="Kyle McConnell" disabled />
                        </label>
                      </div>
                      <div className="cell small-12 large-4">
                        <label className="has-value"><span>Bank Name</span>
                          <input type="text" value="Silicon Valley Bank" disabled />
                        </label>
                      </div>
                      <div className="cell small-12 large-4">
                        <label className="has-value"><span>Account Type</span>
                          <input type="text" value="Checking" disabled />
                        </label>
                      </div>
                      <div className="cell small-12 large-4">
                        <label className="has-value"><span>Bank ABA Routing Number</span>
                          <input type="text" value="048372644" disabled />
                        </label>
                      </div>
                      <div className="cell small-12 large-4">
                        <label className="has-value"><span>Bank Account Number</span>
                          <input type="text" value="XXXXX1234" disabled />
                        </label>
                      </div>
                    </div>

                  </div>
                </div>
              </Column>

            </Grid>
          </Column>
        </Grid>

      </div>
    </section>
  </Fragment>
);

export default FundingInformation;



// WEBPACK FOOTER //
// ./src/containers/pages/FundingInformation/index.js